/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MediaCategory {
    TV = 'TV',
    Digital = 'Digital',
    Social = 'Social Media',
    OOH = 'Out-of-home',
    Radio = 'Radio',
}
